// extracted by mini-css-extract-plugin
export default {"loadingContents":"LoadingModalContents_loadingContents__J4Tnp","loadingStage":"LoadingModalContents_loadingStage__R+1vG","loadingLottie":"LoadingModalContents_loadingLottie__ReOaO"};